module.exports = __webpack_public_path__ + "img/eight.7dca5827.jpg";